export default __webpack_public_path__ + "static/media/2070.ea999012.png";